import { config } from "../../_config";

export const getHostname = (fallback = null) => {
  if (typeof window !== 'undefined') {
    return `${window.location.hostname}${config.basePath}`;
  }

  return fallback;
};
